function expandableDescription() {
    // applied for:
    // custom html, rich text
    // section need class: expandable-description

    var descs = document.querySelectorAll('.custom-html.expandable-description .section__header--text .section__description, .rich-text.expandable-description .rich-text__text');

    if (!descs || descs.length === 0) {
        return;
    }

    descs.forEach(function(desc) {
        desc.classList.add('rte');

        // if it has direct child with .metafield-rich_text_field class, use that as desc
        var metafieldRichTextField = desc.querySelector('.metafield-rich_text_field');
        if (metafieldRichTextField) {
            desc = metafieldRichTextField;
        }

        // get desc html content, and add read more after 2nd p tag, and hide by default
        var descContent = desc.innerHTML;
        var descContentArr = descContent.split('</p>');

        // remove empty string
        descContentArr = descContentArr ? descContentArr.filter(function(item) {
            return item !== '';
        }) : [];

        // when there's more than 1 paragraphs
        if (descContentArr && descContentArr.length > 1) {
            // Store the original full content to restore later
            const originalFullContent = desc.innerHTML;

            let descContentNew = descContentArr[0] + '</p>'; // This will show only the first paragraph initially
            let descContentRest = descContentArr.slice(1).join('</p>');
            let descContentRestNew = '<div class="expandable-description__content-rest">' + descContentRest + '</div>';

            // Update the innerHTML to include Read More and the collapsible content
            desc.innerHTML = descContentNew +
                            '<a href="#" class="btn btn--underline expandable-description__read-more">Read more</a>' +
                            descContentRestNew +
                            '<a href="#" class="btn btn--underline expandable-description__read-less" style="display: none;">Read less</a>'; // Initially hidden

            // Get references to the new elements
            let readMoreButton = desc.querySelector('.expandable-description__read-more');
            let readLessButton = desc.querySelector('.expandable-description__read-less');
            let contentRest = desc.querySelector('.expandable-description__content-rest');

            // Initially hide the rest of the content
            contentRest.style.display = 'none';

            // Add event listener to Read More button
            readMoreButton.addEventListener('click', function(event) {
                event.preventDefault();
                contentRest.style.display = 'block'; // Show the rest of the content
                readMoreButton.style.display = 'none'; // Hide Read More
                readLessButton.style.display = 'inline-block'; // Show Read Less
            });

            // Add event listener to Read Less button
            readLessButton.addEventListener('click', function(event) {
                event.preventDefault();
                contentRest.style.display = 'none'; // Hide the rest of the content
                readMoreButton.style.display = 'inline-block'; // Show Read More
                readLessButton.style.display = 'none'; // Hide Read Less
            });
        }
    });
}

expandableDescription();

function faqDescription() {
    var descs = document.querySelectorAll('.faq-description');
    if (!descs || descs.length === 0) {
        return;
    }
    descs.forEach(function(desc) {
        desc.classList.add('rte');
    });
}

faqDescription();

function checkGiftingInCart() {
    let $cartItemsContainer = document.querySelector('[data-cart-items]');
    let totalItems = 0;
    let totalGiftingItems = 0;
    let totalFlowersItems = 0;
    let giftingProducts = [];
    if ($cartItemsContainer) {
        // console.log('DEBUG: refreshing cart items', $cartItemsContainer);

        let $cartItems = $cartItemsContainer.querySelectorAll('.f-cart-item');
        if ($cartItems && $cartItems.length > 0) {
            $cartItems.forEach(function($cartItem) {
                totalItems++;
                let productTags = $cartItem.getAttribute('data-cart-item-product-tags');
                if (productTags && productTags.includes('Gifting')) {
                    // console.log('DEBUG: found Gifting item in cart', $cartItem);
                    giftingProducts.push($cartItem);
                    totalGiftingItems++;
                }
                let productCategory = $cartItem.getAttribute('data-cart-item-product-category');
                if (productCategory == 'Flowers') {
                    // console.log('DEBUG: product category', productCategory);
                    totalFlowersItems++;
                }
            });
        }
    }

    if (totalItems > 0 && totalGiftingItems > 0 && totalFlowersItems === 0) {
        // alert('Need flowers');

        // delete gifting items from cart one by one, then refresh cart after all done
        const removeGiftingItems = async () => {
            for (const $giftingItem of giftingProducts) {
            let cartItemKey = $giftingItem.getAttribute('data-cart-item');
            if (cartItemKey) {
                // console.log('DEBUG: removing gifting item from cart', cartItemKey);
                try {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                    id: cartItemKey,
                    quantity: 0,
                    }),
                });
                const data = await response.json();
                console.log('DEBUG: cart item removed', data);
                } catch (error) {
                console.error('Error:', error);
                }
            }
            }
            // setTimeout(() => {
            // document.dispatchEvent(new CustomEvent('cart:refresh', {
            //     bubbles: true, detail: { open: false }
            // }));
            // console.log('DEBUG: cart refreshed after removing gifting items');
            // }, 5000);
            alert('Gifting items have been removed from your cart. Please add flower items to proceed with gifting.');
            // reload page
            location.reload();
        };

        removeGiftingItems();

    }

}

checkGiftingInCart();

document.addEventListener('cart:updated', function(evt) {
    // console.log(evt.detail.cart);
    // console.log('DEBUG: cart updated');

    checkGiftingInCart();        
    

});

document.addEventListener('product-ajax:added', function(evt) {
  console.log(evt.detail.product);
//   console.log('DEBUG: product added via ajax');
});


function productCustomFieldsToggle() {
    const toggleCheckbox = document.querySelector('#custom-fields-toggle');
    const productBlocksContainer = document.querySelector('.f-product-single__blocks');

    if (toggleCheckbox && productBlocksContainer) {
        toggleCheckbox.addEventListener('change', function() {
            if (this.checked) {
                productBlocksContainer.classList.add('f-product-single__blocks--custom-fields-visible');
            } else {
                productBlocksContainer.classList.remove('f-product-single__blocks--custom-fields-visible');

                // also cleanup values in the custom fields inputs
                const customFieldInputs = productBlocksContainer.querySelectorAll('.f-product-single__block--custom_field input, .f-product-single__block--custom_field textarea, .f-product-single__block--custom_field select');
                customFieldInputs.forEach(function(input) {
                    if (input.tagName.toLowerCase() === 'select') {
                        input.selectedIndex = 0; // reset select to first option
                    } else {
                        input.value = ''; // clear value for input and textarea
                    }
                });
            }
        });
    }
}

productCustomFieldsToggle();


// zapiet
document.addEventListener('DOMContentLoaded', function() {
    var localStoragePostcodeKey = 'fs_zapiet_delivery_postcode';
    var localStoragePostcode = localStorage.getItem(localStoragePostcodeKey);
    var currentPage = function() {
        if (document.body.classList.contains('template-product')) {
            return 'product';
        } else if (document.body.classList.contains('template-cart')) {
            return 'cart';
        } else {
            return 'other';
        }
    }



    window.ZapietEvent.listen('widget_loaded', function(attributes) {    
        // console.log('DEBUG: widget_loaded event from Zapiet', attributes);

        if (currentPage() == 'product') {

            // if postcode in localstorage exists, set it to the input field #zapiet-delivery-info__input__text
            setTimeout(() => {
            if (localStoragePostcode) {
                // console.log('DEBUG: found postcode in localStorage:', localStoragePostcode);
                var postcodeInput = document.getElementById('zapiet-delivery-info__input__text');
                if (postcodeInput) {
                    postcodeInput.value = localStoragePostcode;
                    // console.log('DEBUG: set postcode input value to:', postcodeInput.value);
                } else {
                    // console.log('DEBUG: postcode input field not found');
                }
            }
            }, 1500);


            // console.log('DEBUG: setting up MutationObserver for Zapiet delivery info on product page');
            
            setTimeout(() => {

            // manually listen the postcode using native mutation observer, since can't find proper zapiet event for this
            const targetNode = document.getElementById('zapiet-delivery-info__content');
            if (targetNode) {
                const config = { attributes: true, childList: true, subtree: false };

                const callback = function(mutationsList, observer) {
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                            // console.log('DEBUG: Zapiet delivery info attributes changed:', mutation);

                            const postcodeInput = document.querySelector('#zapiet-delivery-info__input__text');
                            if (postcodeInput) {
                                const postcodeValue = postcodeInput.value;
                                // console.log('DEBUG: Zapiet delivery postcode:', postcodeValue);
                                // put into localStorage
                                localStorage.setItem(localStoragePostcodeKey, postcodeValue);
                            }
                        }
                    }
                };

                const observer = new MutationObserver(callback);

                observer.observe(targetNode, config);
            }
            }, 1500);
        } else if (currentPage() == 'cart') {
            // if postcode in localstorage exists, set it to the input field #deliveryGeoSearchField
            setTimeout(() => {
            if (localStoragePostcode) {
                // console.log('DEBUG: found postcode in localStorage:', localStoragePostcode);
                var postcodeInput = document.getElementById('deliveryGeoSearchField');
                if (postcodeInput) {
                    postcodeInput.value = localStoragePostcode;
                    // console.log('DEBUG: set postcode input value to:', postcodeInput.value);

                    // workaround to trigger Zapiet to re-check eligibility after setting postcode value
                    // focus and blur to trigger Zapiet
                    postcodeInput.focus();
                    postcodeInput.blur();
                    // scroll to top
                    window.scrollTo(0, 0);
                } else {
                    // console.log('DEBUG: postcode input field not found');
                }
            }
            }, 1000);

        }



    });

    // window.ZapietEvent.listen('eligibilityError', function(attributes) {    
    //     console.log('DEBUG: eligibilityError event from Zapiet', attributes);

    //     // manually listen the postcode
    //     if (currentPage() == 'product') {
            
    //     }

    // });


    // window.ZapietEvent.listen('getDeliveryLocations', function(attributes) {    
    //     console.log('DEBUG: getDeliveryLocations event from Zapiet', attributes);
    // });

    let enableLocationType = true;
    let locationType = document.getElementById('delivery-location-type');
    let locationTypeField = document.getElementById('location-type-field');
    let locationTypeError = document.getElementById('delivery-location-type-error');

    // only at cart
    window.ZapietEvent.listen('locationSelected', function(attributes) {    
        // console.log('DEBUG: locationSelected event from Zapiet', attributes);

        const postcodeInput = document.querySelector('#deliveryGeoSearchField');
        if (postcodeInput) {
            const postcodeValue = postcodeInput.value;
            // console.log('DEBUG: save Zapiet delivery postcode to localStorage:', postcodeValue);
            // put into localStorage
            localStorage.setItem(localStoragePostcodeKey, postcodeValue);
        }

        if (enableLocationType && currentPage() == 'cart') {
            if (locationTypeError) {
                locationTypeError.style.display = 'none';
            }

            if (attributes && attributes.method !== 'delivery') {
                // cleanup location type field
                if (locationTypeField) {
                    locationTypeField.value = '';
                    console.log('DEBUG: clear cart attribute location-types for pickup method');
                }
                if (locationType) {
                    locationType.style.display = 'none';
                    locationType.value = '';

                    // not mandatory
                    locationType.removeAttribute('required');
                }
            }
        }
    });




    // location type is dropdown
    if (enableLocationType && locationType) {
        locationType.addEventListener('change', function() {
            if (locationTypeField) {
                locationTypeField.value = locationType.value;
                // console.log('DEBUG: set cart attribute location-types to:', locationTypeField.value);
                // hide error message
                if (locationTypeError) {
                    locationTypeError.style.display = 'none';
                }
            }
        });
    }

    window.ZapietEvent.listen('delivery.datepicker.rendered', function(attributes) {    
        // console.log('DEBUG: delivery.datepicker.rendered event from Zapiet', attributes);
        if (enableLocationType && locationType) {
            // console.log('DEBUG: Zapiet location type:', locationType.value);

            // show location type field
            locationType.style.display = 'block';

            // set as mandatory
            locationType.setAttribute('required', 'required');
        }
    });
    
    if (enableLocationType) {
        // handle on checkout click, block checkout if location type not selected
        let checkoutButton = document.querySelector('button[name="checkout"]');
        if (checkoutButton) {
            checkoutButton.addEventListener('click', function(event) {
                // block or pass checkout based on location type selection
                if (locationType && locationType.hasAttribute('required') && locationType.value === '') {
                    // alert('Please select a location type before proceeding to checkout.');
                    if (locationTypeError) {
                        locationTypeError.style.display = 'block';
                    }
                    // prevent default action and stop other listeners
                    event.preventDefault();
                    event.stopImmediatePropagation();
                    return false;
                }
            }, true); // Use capture phase to run before other listeners
        }

    }

});

// product details
// shipping info, click to expand accordion tab
document.addEventListener('DOMContentLoaded', function() {
    if (!document.body.classList.contains('template-product')) {
        return;
    }

    const collapsibleTabs = document.querySelectorAll('collapsible-tab[id]');
    if (!collapsibleTabs || collapsibleTabs.length === 0) {
        return;
    }

    const shippingInfoLinks = document.querySelectorAll('.f-product-single__block--shipping a[href^="#"]');
    if (!shippingInfoLinks || shippingInfoLinks.length === 0) {
        return;
    }
    shippingInfoLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            const targetId = this.getAttribute('href').substring(1);
            // find collapsible tabs with same id
            collapsibleTabs.forEach(function(tab) {
                if (tab.id === targetId) {
                    // // open the tab
                    const tabButton = tab.querySelector('.collapsible__button');
                    if (tabButton) {
                        if (tabButton.getAttribute('aria-expanded') === 'false') {
                            tabButton.click();
                        }
                    }
                    // scroll to the tab
                    const yOffset = -100;
                    const y = tab.getBoundingClientRect().top + window.pageYOffset + yOffset;
                    window.scrollTo({ top: y, behavior: 'smooth' });
                }
            });
        });
    });    
});
